<template>
    <div class="papsi-wrapper">
        <h1 class="text-2xl font-semibold text-[#24723b]">Indorsement Signatory for Training Requisition Form</h1>
        <p class="text-xs text-[#747474] mt-2">Home / Form Training Requisition Form</p>
    </div>
    <div class="flex flex-col gap-6 mt-11 bg-[#f0f0f0] border-[#ffffff41] border-[3px] py-8 px-11 rounded-md shadow">
        <div class="flex gap-5">
            <div class="w-full">
                <label class="text-sm text-[#24723b]">Office/Division</label>
                <select class="w-full border-2 border-[#afafaf] p-2 py-3 text-sm rounded-md" v-model="vdivision">
                    <option  class="text-[#816c6c]" selected disabled value="">Please select Office/Division</option>
                    <option v-for="(row , index) in division" :key="index" :value="row.fdiv_key">{{ row.fdiv_desc }}</option>
                </select>
            </div>
            <div class="w-full ">
                <label class="text-sm text-[#24723b]">Indorsement Approval</label>
                <select class="w-full border-2 border-[#afafaf] p-2 py-3 text-sm rounded-md" v-model="vdepartment">
                    <option selected disable value="">Select Indorsement Approval</option>
                    <option v-for="(row , index) in GetName" :key="index" :value="row.femp_key" >{{ row.ff_name + " " + row.fm_name + " " + row.fl_name }}</option>
                </select>
            </div>
        </div>
    </div>
            <div class="w-full flex justify-center">
                <button class="w-[200px] text-white bg-[#24723b] mt-11 p-2 rounded-md flex justify-center py-2">Add Digital Signatory</button>
            </div>
    <div class="pt-6 mt-11 border-t border-[#ccc4c4] px-11 bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow " >
        
            <h1 class="font-semibold text-[#24723b] mt-4">Indorsement Signatory</h1>
            <div class="flex gap-5 mt-7">
                <div class="w-[50%]">
                    <label class="text-sm text-[#24723b]">Division/Office Executive (Approval)</label>
                        <p class="text-lg text-[#575757] mt-1">LHAN ZELL OBLIDA REYES</p>
                </div>
            </div>
            <div class="flex justify-center mt-11">
            </div>
            <div class="mt-11 border-t border-[#ccc4c4] py-7">
                <h1 class="font-semibold text-2xl text-[#24723b]">OHR DETAILS</h1>
                <div class="flex gap-5 mt-6">
                    <div class="w-full">
                        <label class="text-sm">Recommended by:</label>
                        <p class="text-xl">ALMA D. OCHOCO</p>
                        <label class="text-sm">Learning & Developmnent Manager</label>
                    </div>
                    <div class="w-full">
                        <label class="text-sm">Approved by:</label>
                        <p class="text-xl">MIRAFLOR A. CABALAN</p>
                        <label class="text-sm">Vice President For Human Resources</label>
                    </div>
                </div>
            </div>
            
    </div>
</template>
<script>
import axios from "axios";
import { defineComponent } from 'vue';

export default defineComponent(
{
    components:{
    },
    data(){ 
        return{
            GetName:      '',
            division:     '',
            vdivision:    '',
            vdepartment:  '',
            
        }
     },
    mounted(){
        this.getAllDivision()
        this.getName()
    },
    methods:{
        getName(){
            axios.request({
            method: "GET",
            url:'http://127.0.0.1:8000/api/v1/ohr/Employee-name'})
            .then(response => (
                this.GetName = response.data.data
            ))

        },
        getAllDivision(){
            axios.request({
            method: "GET",
            url:'http://127.0.0.1:8000/api/v1/ohr/GetallDivision'})
            .then(response => (
                this.division = response.data.data
            ))
        },

    }
})
</script>